import { defineStore } from 'pinia'

// 3 套主题，跟 src/styles/tokens.css 里的 [data-theme="..."] 一一对应。
export type ThemeName = 'default' | 'wechat' | 'apple'
export type ThemePreference = ThemeName

/** 控件形态：圆角 / 方形 —— 桌面端个人偏好，与小程序装修独立 */
export type ShapeName = 'rounded' | 'square'

const THEME_STORAGE_KEY = 'fabric.theme'
const SHAPE_STORAGE_KEY = 'fabric.shape'

function readInitialTheme(): ThemeName {
  const v = localStorage.getItem(THEME_STORAGE_KEY)
  if (v === 'wechat' || v === 'apple' || v === 'default') return v
  if (v === 'system') {
    localStorage.setItem(THEME_STORAGE_KEY, 'default')
    return 'default'
  }
  return 'default'
}

function readInitialShape(): ShapeName {
  const v = localStorage.getItem(SHAPE_STORAGE_KEY)
  if (v === 'square' || v === 'rounded') return v
  return 'rounded'
}

export const useThemeStore = defineStore('theme', {
  state: () => ({
    preference: readInitialTheme(),
    shape: readInitialShape()
  }),
  getters: {
    effective(state): ThemeName {
      return state.preference
    }
  },
  actions: {
    set(name: ThemeName) {
      this.preference = name
      localStorage.setItem(THEME_STORAGE_KEY, name)
      this.applyToDom()
    },
    setShape(name: ShapeName) {
      this.shape = name
      localStorage.setItem(SHAPE_STORAGE_KEY, name)
      this.applyToDom()
    },
    applyToDom() {
      document.documentElement.setAttribute('data-theme', this.effective)
      document.documentElement.setAttribute('data-shape', this.shape)
    }
  }
})
